module.exports = __webpack_public_path__ + "static/media/sprite.f136dc13.svg";